import React, {useState, useEffect, useContext} from 'react';
import SavedSearchListItem from './SavedSearchListItem';
import {Collapse} from 'reactstrap';
import {connect} from 'react-redux';
import {sortAlphabetically} from 'utils/other';
import {filterByValue} from 'Helpers/filterByValue';
import SearchInput from 'components/SearchInput';
import {SavedSearchContext} from 'contexts/SavedSearchContext';
import './style.scss';
import Tooltip from 'components/Tooltip';

const SavedSearchList = (props) => {
    const {activeSavedSearch, setActiveSavedSearch, setDeletedSavedSearchId, setSavedSearchPeriodFilter} = useContext(SavedSearchContext);
    const {
        savedSearchesLoading, setSavedSearchesLoading, savedSearches, resetSearchValues,
        auth, usersList, handleAssignAlert, assigningSavedSearch, refreshSavedSearches,
    } = props;
    const [visibleList, setVisibleList] = useState([]);
    const [searchValue, setSearchValue] = useState('');

    useEffect(() => {
        if(savedSearches) {
            let filteredArr = searchValue.length ? filterByValue(savedSearches, 'sourceName', searchValue) : [...savedSearches];
            setVisibleList(filteredArr);
        }
    }, [searchValue, savedSearches]);

    const resetSearch = () => setSearchValue('');

    const handleAddBtnClick = () => {
        resetSearchValues();
    };

    return (
        <>
            <div className="home-page-left-column__header">
                <div className="home-page-left-column__title">
                    Saved Searches
                </div>
                <Tooltip placement="bottom" wide tooltip={`Create Search`}>
                    <div
                        className="home-page-left-column__add-btn"
                        onClick={handleAddBtnClick}
                        data-tip="Create Search"
                    >
                        <i className="fas fa-plus"/>
                    </div>
                </Tooltip>
                {/*<ReactTooltip*/}
                {/*    place="bottom"*/}
                {/*    // effect="solid"*/}
                {/*    delayShow={400}*/}
                {/*    className="tooltip-thin"*/}
                {/*/>*/}
            </div>
            {savedSearches && savedSearches.length > 0 &&
            <div className="home-page-left-column__search">
                <div style={{padding: '10px 15px'}}>
                    <SearchInput
                        value={searchValue}
                        onChange={setSearchValue}
                        placeholder="Search saved searches"
                        onClear={resetSearch}
                    />
                </div>
            </div>
            }
            <div className="home-page-left-column__body">
                {savedSearches && savedSearches.length === 0 ?
                    <div style={{padding: '20px 15px 10px'}}>No saved searches have been created yet.</div>
                    :
                    visibleList && sortAlphabetically(visibleList, 'sourceName').map(search => (
                        <SavedSearchListItem
                            item={search}
                            key={search.id}
                            auth={auth}
                            setActiveSavedSearch={setActiveSavedSearch}
                            savedSearchesLoading={savedSearchesLoading}
                            setSavedSearchesLoading={setSavedSearchesLoading}
                            setSavedSearchPeriodFilter={setSavedSearchPeriodFilter}
                            // deletingSavedSearch={deletingSavedSearch}
                            // setDeletingSavedSearch={setDeletingSavedSearch}
                            // isActive={Boolean(activeSavedSearch && (activeSavedSearch.id === search.id))}
                            activeSavedSearch={activeSavedSearch}
                            usersList={usersList}
                            handleAssignAlert={handleAssignAlert}
                            assigningSavedSearch={assigningSavedSearch}
                            refreshSavedSearches={refreshSavedSearches}
                            setDeletedSavedSearchId={setDeletedSavedSearchId}
                            resetSearchValues={resetSearchValues}
                        />
                    ))}
            </div>
        </>
    );
};

const mapStateFromProps = ({auth}) => ({
    auth,
});

export default connect(mapStateFromProps, null)(SavedSearchList);